import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function CTASection({ title, text, ctaLabel = "Parla con noi", testid = "cta-parla-con-noi" }) {
    return (
        <section className="py-20 sm:py-28">
            <div className="wrap">
                <Reveal>
                    <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-surface px-8 py-14 sm:px-14 sm:py-16 text-center">
                        <div
                            className="absolute -top-24 left-1/2 -translate-x-1/2 h-64 w-[36rem] rounded-full pointer-events-none"
                            style={{ background: "radial-gradient(closest-side, rgba(0,210,255,0.16), rgba(0,0,0,0))" }}
                        />
                        <h2 className="relative font-display text-2xl sm:text-4xl font-bold text-white tracking-tight leading-tight">
                            {title}
                        </h2>
                        {text && <p className="relative mt-4 text-slate-400 max-w-xl mx-auto leading-relaxed">{text}</p>}
                        <div className="relative mt-9">
                            <Link to="/contatti" data-testid={testid} className="btn-primary">
                                {ctaLabel}
                                <ArrowRight className="h-4 w-4" />
                            </Link>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
